<template>
  <div class="page">
    <ion-grid>
      <ion-row  align-items-stretch>
        <ion-col size="12" size-md="6" v-for="item in allNotifications" :key="item">
          <ion-card @click= "openNotificationDetailsPage(item)" class="ion-card">
            <ion-card-content class="vh-content">
              <ion-row>
                <ion-col text-left size="6">
                  <span v-if="item.notificationViewedByUser == 'Y'"><img class="read-img" src="/assets/images/notifications/not1.png"/></span>
                  <span v-else="item.notificationViewedByUser == 'N'"><img class="read-img" src="/assets/images/notifications/not2.png"/></span>
                  <span><ion-label class="book-ref" :class="item.notificationViewedByUser == 'Y' ? 'viewed' : 'not-viewed'">{{item.notificationType}}</ion-label></span>
                </ion-col>
                <ion-col text-right size="6">
                  <ion-label class="book-day"> {{changeDateFormat(item.createdOn)}} </ion-label>
                </ion-col>
              </ion-row>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div> 
</template>

<script>
import { defineComponent } from "vue";
import { Notifications } from '../../service/notifications/notifications.service';
import { LocalStorage } from "../../data/localstorage";
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import moment from "moment";

export default defineComponent ({
  name: 'Notifications',
  data() {
    return {    
      allNotifications: "",
      iconName: "",
      loaderTab: true
    }
  },
  async mounted() {
    try {
      let user = new LocalStorage().user;
      if(user) {
        let notificationsList = await new Notifications().getAllNotifications(user.id);
        
        if(notificationsList.data.data.length > 0) {
          this.allNotifications = notificationsList.data.data;
        } else {
          new ToastUtils().presentToast("There is no notifications.");
        }

        this.loaderTab = false;
      }
    } catch(error) {
      this.loaderTab = false;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },
  methods: {
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
    getStatusClass(data) {
      if(data.notificationViewedByUser == "N") {
        return "not-viewed";
      } else {
        return "viewed";
      }
    },
    async openNotificationDetailsPage(notificationsDetails) {
      localStorage.setItem("notificationDetails", JSON.stringify(notificationsDetails))
      this.$router.push("/notifications/notificationDetails")
      // this.$router.push({
      //   name: "notificationDetails",
      //   props : { notificationId: notificationsDetails.id,
      //     userId: notificationsDetails.userId },
      // });
    }
  }
})
</script>

<style scoped>
ion-card {
  /* height: 84px; */
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
  cursor: pointer;
}

.book-ref {
  text-align: right;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #041648;
  opacity: 1;
  vertical-align: super;
  margin-left: 10px;
}

.book-day {
  text-align: right;
  font-family: "Roboto Medium";
  font-size: 14px;
  letter-spacing: 0;
  color: #000000;
  opacity: 1;
}

.book-amount {
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 15px;
  color: #21b24b;
  opacity: 1;
}

.book-location {
  text-align: left;
  font-family: "Roboto";
  font-size: 15px;
  letter-spacing: 0;
  color: #414141;
  opacity: 1;
}
.vh-content {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 16px;
  opacity: 1;
}
.unavailable {
  background: #e27b7b 0% 0% no-repeat padding-box;
}
.read-img {
  width: 8%;
  display: inline-block;
}

.not-viewed {
  font-weight: bold;
  font-size: 1rem;
}
@media screen and (max-width: 720px) {
  .read-img {
    width: 12%;
    display: inline-block;
  }
  .not-viewed {
    font-weight: bold;
    font-size: 0.9rem;
  }
}

</style>